/* global AP */

import React, { useEffect } from 'react';
import Button from '@atlaskit/button';

/**
 * Open the UAMC using the hidden form in the HTML.
 */
const openUAMC = async () => {
  try {
    document.getElementById('uamcForm').submit();
  } catch (error) {
    console.error("Unable to open UAMC.");
  }
}

/**
 * Dynamically fill in the form with the relevant information .
 */
const updateForm = async () => {

  const form = document.getElementById('uamcForm');

  // REST calls to get the Jira objects
  const issueId = await getIssueId();

  // Update work item id
  form.WorkItemId.value = issueId;
}

/**
 * Uses the Atlassian Javascript API to get the context.
 */
const getContext = async () => {
  const response = await new Promise(resolve => {
    AP.context.getContext(resolve);
  });
  return response;
}

/**
 * Get the issue id for the request.
 */
const getIssueId = async () => {
  const context = await getContext();
  return context.jira.issue.id;
}

export default () => {
  useEffect(() => {
    (async () => {
      try {
        await updateForm();
      } catch (error) {
        console.error("Unable to get UAMC fields." + error);
      }
    })();
  }, []);

  return (
    <>
      <div style={{ padding: '4px 4px' }}>
        <Button
          appearance="primary"
          onClick={openUAMC}
        >Open UAMC</Button>
      </div>
    </>
  );
};
